import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { IntlFieldGroup } from "../../../common/form";
import { intlShape, FormattedMessage } from "react-intl";
import validationUtils from "../../../../utils/ValidationUtils";
import { INSURER_VALIDATION_RULES } from "./insurerValidationRules";
import { INSURERS } from "../../../../utils/data/models";
import MultiSectionsModal from "../../../common/Modals/MultiSectionsModal";
import InsurerContact from "./formSections/InsurerContact";
import InsurerGeneralInformation from "./formSections/InsurerGeneralInformation";
import InsurerAccounts from "./formSections/InsurerAccounts";

export class BasicInsurerFields extends React.Component {
  static generateLocalizedRules(model) {
    let newRules = { ...INSURER_VALIDATION_RULES };

    INSURERS.localizedFields.map((field) => {
      Object.keys(model.localizations).map((locale) => {
        const fieldName = `localizations['${locale}'].${field}`;

        newRules[fieldName] = newRules[field];
      });
    });
    INSURERS.localizedFields.map((field) => {
      delete newRules[field];
    });

    return newRules;
  }

  constructor(props, context) {
    super(props, context);

    this.generateLocalizedFields = this.generateLocalizedFields.bind(this);
  }

  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  generateLocalizedFields() {
    return INSURERS.localizedFields.map((field) => {
      return (
        <IntlFieldGroup
          key={field}
          field={field}
          required={true}
          labelKey={`admin.insurers.form.generalInformation.${field}`}
          localizations={this.props.initialValues.localizations}
        />
      );
    });
  }

  render = () => {
    const { handleSubmit, invalid } = this.props;
    return (
      <div>
        <MultiSectionsModal
          handleSubmit={handleSubmit}
          bodyClasses="InsurerModalBody"
          disableNavigation={invalid}
          revealErrors={handleSubmit}
        >
          {[
            {
              sectionName: (
                <FormattedMessage id="admin.insurers.form.generalInformation.title" />
              ),
              section: (
                <InsurerGeneralInformation
                  generateLocalizedFields={this.generateLocalizedFields}
                />
              ),
            },
            {
              sectionName: (
                <FormattedMessage id="admin.insurers.form.contacts.title" />
              ),
              section: <InsurerContact />,
            },
            {
              sectionName: (
                <FormattedMessage id="admin.insurers.form.accounts.title" />
              ),
              section: <InsurerAccounts />,
            },
          ]}
        </MultiSectionsModal>
      </div>
    );
  };
}

BasicInsurerFields.propTypes = {
  initialValues: PropTypes.object,
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
  translateFn: PropTypes.func,
  invalid: PropTypes.bool,
  touch: PropTypes.func,
};

BasicInsurerFields.defaultProps = {
  scene: "",
};

BasicInsurerFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

BasicInsurerFields.childContextTypes = {
  scene: PropTypes.string,
};

export default connect(null, null, null, { withRef: true })(
  reduxForm({
    form: "insurer",
    validate: (values) =>
      validationUtils.validate(
        values,
        BasicInsurerFields.generateLocalizedRules(values)
      ),
  })(BasicInsurerFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/insurers/BasicInsurerFields.js